

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectSmsComponent } from './select-sms.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SelectSmsComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    
  ],

  exports: [SelectSmsComponent],
  entryComponents: [SelectSmsComponent],
})
export class SelectSmsModule { }
